import { ClassRating } from "constants/rate-classes";
import { IPrimaryUser } from "services/api/api.types";
import {
  IRestructuredPendingFeedbacksAPIResponse,
  PendingClassRatingStatus
} from "services/api/class-feedback/classFeedbackService.types";

export interface IUseRateClassProps {
  primaryUser: IPrimaryUser;
  showLatestPendingReviewModal: boolean;
}

export interface IPendingClassRating {
  id: string;
  subject: Subject;
  teachers: Teacher[];
  liveClass: LiveClass;
  previousState: PendingClassPreviousState | null;
}

interface PendingClassPreviousState {
  rating: ClassRating;
  userFeedbackId: string;
  liveClassId: string;
  status: PendingClassRatingStatus;
}

interface LiveClass {
  id: string;
  title: string;
}
interface Subject {
  id: string;
  name: string;
  logo: string | null;
}

interface Teacher {
  id: string;
  name: string;
}

export enum ModalSource {
  FEEDBACK_SECTION = "live class feedback section",
  TAB_VIEWED = "live class tab viewed"
}

export interface IRateClassModalData extends IPendingClassRating {
  rating?: ClassRating;
  modalSource: ModalSource;
}

export interface IUseRateClassReturnValues {
  pendingClassRatings: IPendingClassRating[];
  metaData: IRestructuredPendingFeedbacksAPIResponse["metaData"];
  modalData: IRateClassModalData | null;
  openRatingModal: (data: IRateClassModalData) => void;
  isModalOpen: boolean;
  closeRatingModal: () => void;
}
